angular.module('TargetPerformanceNewCtrl', [])
  .controller('TargetPerformanceNewCtrl', function ($q, $scope, $rootScope, $timeout, TargetPerformanceNewState, Models, Tabs) {
    var pendingLookupTimers = [];
    var MODEL_LOOKUP_MAX_ATTEMPTS = 12;
    var MODEL_LOOKUP_RETRY_MS = 250;

    function clearPendingLookupTimers() {
      pendingLookupTimers.forEach(function (timerId) {
        clearTimeout(timerId);
      });
      pendingLookupTimers = [];
    }

    function openModelDetailsById(id, attempt) {
      var modelList = Models.getModelList() || [];
      var model = modelList.find(function (m) { return m.id == id; });

      if (model) {
        Models.currentModel = model;

        var tab = Tabs.addTab('model');

        if (tab) {
          tab.active = true;
          Tabs.setActiveTab(tab);
          Tabs.setLastActive(tab);

          $scope.$applyAsync(function () {
            if ($scope.$parent && $scope.$parent.$broadcast) {
              $scope.$parent.$broadcast('tabSwitched::' + tab.type, tab);
            }
            $rootScope.$broadcast('tabSwitched::' + tab.type, tab);
          });

          // Backup broadcast after tab mount/compile for paths where the first broadcast is too early.
          $timeout(function () {
            if ($scope.$parent && $scope.$parent.$broadcast) {
              $scope.$parent.$broadcast('tabSwitched::' + tab.type, tab);
            }
            $rootScope.$broadcast('tabSwitched::' + tab.type, tab);
          }, 100, false);
        } else {
          console.warn('[SMX target-performance-new] unable to open legacy model details: Tabs.addTab returned no tab', {
            modelId: id
          });
        }

        return;
      }

      if (attempt >= MODEL_LOOKUP_MAX_ATTEMPTS) {
        console.warn('[SMX target-performance-new] unable to open legacy model details: model not found after retries', {
          modelId: id,
          attempt: attempt,
          maxAttempts: MODEL_LOOKUP_MAX_ATTEMPTS,
          modelListLength: modelList.length
        });
        return;
      }

      var timerId = setTimeout(function () {
        openModelDetailsById(id, attempt + 1);
      }, MODEL_LOOKUP_RETRY_MS);
      pendingLookupTimers.push(timerId);
    }

    function onOpenLegacyModelDetails(event) {
      var id = event.detail && event.detail.objectId;
      if (!id) {
        console.warn('[SMX target-performance-new] unable to open legacy model details: missing detail.objectId', {
          eventType: event && event.type,
          detail: event && event.detail
        });
        return;
      }

      openModelDetailsById(id, 1);
    }

    function requestBuilderOpen() {
      TargetPerformanceNewState.requestNewBuilder();
      $rootScope.$broadcast('target-performance-new:show-new-builder');
    }

    function broadcastTabSwitch(tab) {
      var eventName = 'tabSwitched::' + tab.type;

      if ($scope.$parent) {
        $scope.$parent.$broadcast(eventName, tab);
      }

      $rootScope.$broadcast(eventName, tab);
    }

    function openModelDetailsById(id, attempt) {
      var modelList = Models.getModelList() || [];
      var model = modelList.find(function (item) {
        return item.id == id;
      });

      if (!model) {
        if (attempt < 5) {
          $timeout(function () {
            openModelDetailsById(id, attempt + 1);
          }, 250, false);
          return;
        }

        console.warn('_smx-open-legacy-model-details failed: model not found', {
          objectId: id,
          modelListLength: modelList.length
        });
        return;
      }

      Models.currentModel = model;

      var tab = Tabs.addTab('model');
      if (!tab) {
        console.warn('_smx-open-legacy-model-details failed: model tab was not created', {
          objectId: id,
          modelId: model.id
        });
        return;
      }

      Tabs.setActiveTab(tab);
      Tabs.setLastActive(tab);

      $scope.$applyAsync(function () {
        broadcastTabSwitch(tab);
      });

      $timeout(function () {
        broadcastTabSwitch(tab);
      }, 50, false);
    }

    function onOpenPortfolioBuilder() {
      requestBuilderOpen();
      $q.when($scope.addTab('portfolio-builder'))
        .then(function () {
          if (!$scope.$$phase && !$rootScope.$$phase) {
            $scope.$digest();
          }
        });
    }

    function onOpenLegacyModelDetails(event) {
      var id = event.detail && event.detail.objectId;

      if (!id) {
        console.warn('_smx-open-legacy-model-details failed: missing objectId', {
          detail: event.detail
        });
        return;
      }

      openModelDetailsById(id, 0);
    }

    document.addEventListener('_smx-open-portfolio-builder', onOpenPortfolioBuilder);
    document.addEventListener('_smx-open-legacy-model-details', onOpenLegacyModelDetails);

    $scope.$on('$destroy', function () {
      clearPendingLookupTimers();
      document.removeEventListener('_smx-open-portfolio-builder', onOpenPortfolioBuilder);
      document.removeEventListener('_smx-open-legacy-model-details', onOpenLegacyModelDetails);
    });
  });